import React from 'react'

import classNames from 'classnames'

import { IconWrapper } from '../components'

export const IconSliceCurlyArrowDown = ({
  size,
  color,
  className,
  ...props
}: React.ComponentPropsWithoutRef<'svg'> & {
  size?: string | number
}) => (
  <IconWrapper {...props} className={classNames(className, "icon-centivo", "icon-centivo--slice-curly-arrow-down")} iconColor={color} size={size} width="18" height="25" viewBox="0 0 18 25" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M17 15.7039C13.9084 15.4902 9.05013 17.0502 9.05013 25L9.05013 1.36211e-06M0.999998 15.7039C4.09161 15.4902 8.94986 17.0502 8.94986 25" stroke="currentColor" strokeWidth="1.08868"/>
  </IconWrapper>
)
